import TextField from '@mui/material/TextField';

const FromTextField = ({
  onChange = (event: any) => { onChange(event); }
}) => (
  <TextField id="tfkobaicyumonno"
    label="注文番号"
    size="small"
    inputProps={{ maxLength: 11 }}
    onChange={(event: any) => { onChange(event); }}
  />
);

export default FromTextField;